import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useStaticQuery, graphql } from "gatsby"
import Button from '../../components/button';
import { Titlespan, Description } from '../../components/title/index';
import Image from '../../components/image/index';
import BannerImg1 from '../../assets/images/banner/banner-round-bg.png';
import Shape2 from '../../assets/images/banner/bg-wave.svg';
import Shape3 from '../../assets/images/banner/wave.png';
import './banner.scss';

function Banner(props) {
    const BannerAnimationImages = useStaticQuery(graphql`
        query BackgroundImages {
            allDataJson {
                edges {
                    node {
                        bannerranimation {
                        img
                        }
                    }
                }
            }
        }
    `)

    return (
        <section className={`banner-wrapper ${props.ChangeClass} ${props.page} ${props.home ? '' : 'banner-wrapper--no-image'}`} id="home">
            <div className="banner-outer">
                <div className="slider-animation-images">
                    {BannerAnimationImages.allDataJson.edges[0].node.bannerranimation.map((img, index) => (
                        <span className={`image${index + 1}`} key={`banner-${index}`} >
                            <Image Path={'/' + img.img} />
                        </span>
                    ))}
                </div>
                <Container>
                    <Row>
                        <Col md={6}>
                            <div className="banner-content">
                                <Titlespan
                                    Class="banner-main-title"
                                    Label=""
                                    Name={props.title}
                                />
                                {props.body && <Description
                                    Class="banner-dec"
                                    Name={props.body}
                                />}
                                <div className="banner-btn-wrapper">
                                    {props.btnText && <Button
                                        Class="button1 button3 btn"
                                        Name={props.btnText}
                                    />}
                                    {props.contactBtn ? <Button
                                        Class="button1 button4 btn"
                                        Name="Contact Us"
                                        Title="gradient-color"
                                        BtnIcon="btn-icon gradient-color1"
                                    /> : null}
                                </div>
                            </div>
                        </Col>
                        <Col md={6} className={props.home ? '' : 'd-none'}>
                            <div className="banner-image">
                                <Image
                                    Path={BannerImg1}
                                    Class="banner-img"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>

                {(props.ChangeClass === 'demo2' || props.ChangeClass === 'demo3') &&
                    <div className="bottom-img">
                        {props.ChangeClass === 'demo2' ?
                            <Image Path={Shape2} /> :
                            <Image Path={Shape3} />
                        }
                    </div>
                }
            </div>
        </section>
    );
}

export default Banner;
